import { colors } from '@giphy/react-giphy-brand'

const defaultStory = {
    story_id: '',
    user: null,
    title: '',
    description: '',
    gifs: [],
    tags: [],
    cover_gif: null,
    is_private: true,
    color: colors.giphyPurple,
    slug: '',
    create_datetime: '',
    publish_datetime: new Date().toISOString(),
    secondary_color: colors.giphyIndigo,
    category: '',
}
export const WIP_STORY = Symbol('wip_story')
// define a story_id so finalize page doesn't wait to render
export const wipStory = { ...defaultStory, storyType: WIP_STORY }

export default defaultStory
